<file-picker
  [offlineUpload]="true"
  [emitOfflineAssets]="true"
  (assetsAdded)="onAssetsAdded($event)"
>
</file-picker>

<!-- Saved assets -->

<ng-container *ngIf="assocObject.id && assocObject.examples != null">
  <div
    *ngFor="let item of assocObject.examples; index as i"
    class="align-middle"
    [ngClass]="getAssetClass(item)"
    matTooltip="{{ item?.asset?.name }}"
  >
    <div class="d-flex box click-link">
      <a
        download="{{ item.asset.name }}"
        [href]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
        style="margin-right: 7px"
        class="d-flex box"
      >
        <div class="filename">
          {{ item?.asset?.name | shortenTextSplitOn : '.' : 10 }}
        </div>

        <a>
          <mat-icon aria-hidden="false" aria-label="remove">
            cloud_download
          </mat-icon>
        </a>
      </a>

      <a>
        <mat-icon
          style="cursor: pointer"
          aria-hidden="false"
          aria-label="remove"
          (click)="removeOnlineFile(i)"
        >
          delete
        </mat-icon>
      </a>
    </div>

    <div>
      <img
        *ngIf="isImage(item.asset)"
        [src]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
      />
    </div>
  </div>
</ng-container>

<!-- Offline assets -->

<ng-container *ngIf="assocObject.offlineExamples?.length > 0">
  <div
    *ngFor="let item of assocObject.offlineExamples; index as i"
    class="align-middle loadedImg asset-left-space"
    matTooltip="{{ item?.name }}"
  >
    <div class="d-flex box click-link">
      <a
        download="{{ item.name }}"
        [href]="item.uuid | assetSource : item.localSafeUrl"
        style="margin-right: 7px"
        class="d-flex box"
      >
        <div class="filename">
          {{ item?.name | shortenTextSplitOn : '.' : 10 }}
        </div>

        <a>
          <mat-icon aria-hidden="false" aria-label="remove">
            cloud_download
          </mat-icon>
        </a>
      </a>

      <mat-icon
        style="cursor: pointer"
        aria-hidden="false"
        aria-label="remove"
        (click)="removeOfflineFile(item, i)"
      >
        delete
      </mat-icon>
    </div>

    <div>
      <img
        *ngIf="isImage(item)"
        [src]="item.uuid | assetSource : item.localSafeUrl"
      />
    </div>
  </div>
</ng-container>
